import { render, staticRenderFns } from "./screenSix.vue?vue&type=template&id=bc70c0c4&scoped=true"
import script from "./screenSix.vue?vue&type=script&lang=js"
export * from "./screenSix.vue?vue&type=script&lang=js"
import style0 from "./screenSix.vue?vue&type=style&index=0&id=bc70c0c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc70c0c4",
  null
  
)

export default component.exports